import { uploadAsset } from './upload-assets'

type UploadEventAssetsParams = {
  coverFile?: File
  bannerFile?: File
  eventSlug: string
}

export async function uploadEventAssets({
  coverFile,
  bannerFile,
  eventSlug,
}: UploadEventAssetsParams) {
  const [coverFiles, bannerFiles] = await Promise.all([
    coverFile
      ? uploadAsset({
          file: coverFile,
          folder: 'events',
          title: eventSlug,
          visibility: 'public',
        })
      : Promise.resolve([]),
    bannerFile
      ? uploadAsset({
          file: bannerFile,
          folder: 'events',
          title: eventSlug,
          visibility: 'public',
        })
      : Promise.resolve([]),
  ])

  return {
    coverFile: coverFiles[0],
    bannerFile: bannerFiles[0],
  }
}
